import React, { useContext, useEffect, useMemo, useState } from 'react';
import { observer, useLocalStore } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { withErrorBoundary } from 'react-error-boundary';

import { CenteredLoadingSpinner, Table } from '@ole-ui/ole-ui-components';
import { handleError } from 'services/ErrorService';
import GenericViewError from 'components/Error/GenericViewError';
import { storesContext } from 'stores';
import TotalHourStore from './store';
import UserMetricsEmptyState from '../EmptyState';

const TotalHoursTable = () => {
  const { t, i18n } = useTranslation();
  const { organizationStore } = useContext(storesContext);
  const store = useLocalStore(() => new TotalHourStore(organizationStore));
  const [isLoading, setIsLoading] = useState(false);

  const columnDefinitions = useMemo(
    () => [
      {
        Header: t('User name'),
        accessor: 'username',
        id: 'username',
      },
      {
        Header: t('Total Training Hours'),
        accessor: 'count',
      },
    ],
    [i18n.language],
  );

  useEffect(() => {
    let cancelled = false;
    const controller = new AbortController();
    setIsLoading(true);
    const timer = setTimeout(async () => {
      try {
        await store.getReporteesHours(
          organizationStore.selectedUsersByManagerList,
          controller.signal,
        );
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    }, 1000);
    return () => {
      cancelled = true;
      clearTimeout(timer);
      controller.abort();
      setIsLoading(false);
    };
  }, [organizationStore.selectedUsersByManagerList]);

  const renderEmptyState = () => {
    return (
      <UserMetricsEmptyState
        selectedCount={organizationStore.selectedUsersByManagerList?.length}
      />
    );
  };

  if (isLoading) return <CenteredLoadingSpinner />;

  return (
    <React.Fragment>
      <div className="table-horiz-scroll">
        <Table
          ariaLabel={t('Time spent studying table')}
          data={store.filteredData}
          columns={columnDefinitions}
          variant="compact"
          renderEmptyState={renderEmptyState}
        />
      </div>
    </React.Fragment>
  );
};

export default withErrorBoundary(
  observer(TotalHoursTable),
  GenericViewError,
  handleError,
);
